export default __webpack_public_path__ + "static/media/7minfitness@2x.5cd6e5a8.jpg";